import { currentLanguage } from "./utils.js";

export class ApiClient {
  constructor(log, onMetric = null) {
    this.log = log;
    this.onMetric = onMetric;
    this.sessionToken = localStorage.getItem("vibe-session-token") || "";
  }

  setSessionToken(token) {
    this.sessionToken = token || "";
    if (this.sessionToken) {
      localStorage.setItem("vibe-session-token", this.sessionToken);
    } else {
      localStorage.removeItem("vibe-session-token");
    }
  }

  async request(path, options = {}) {
    const headers = {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    };
    if (this.sessionToken) {
      headers.Authorization = `Bearer ${this.sessionToken}`;
    }
    const separator = path.includes("?") ? "&" : "?";
    const localizedPath = `${path}${separator}lang=${encodeURIComponent(currentLanguage())}`;
    const startedAt = performance.now();
    let response = null;
    try {
      response = await fetch(localizedPath, { ...options, headers });
      const text = await response.text();
      const body = text ? JSON.parse(text) : null;
      if (!response.ok) {
        throw new Error(this.formatError(body?.detail || response.statusText));
      }
      return body;
    } finally {
      const durationMs = Math.round(performance.now() - startedAt);
      this.onMetric?.({
        path,
        durationMs,
        status: response?.status || 0,
        slow: durationMs >= 750,
      });
    }
  }

  websocketUrl(mapId) {
    const protocol = window.location.protocol === "https:" ? "wss" : "ws";
    return `${protocol}://${window.location.host}/ws/maps/${mapId}?lang=${encodeURIComponent(currentLanguage())}`;
  }

  formatError(detail) {
    if (!detail) {
      return "Request failed.";
    }
    if (typeof detail === "string") {
      return detail;
    }
    if (Array.isArray(detail)) {
      return detail.map((entry) => this.formatErrorEntry(entry)).filter(Boolean).join(" | ") || "Request failed.";
    }
    return this.formatErrorEntry(detail) || "Request failed.";
  }

  formatErrorEntry(entry) {
    if (!entry || typeof entry !== "object") {
      return String(entry || "");
    }
    const location = Array.isArray(entry.loc) ? entry.loc.filter((part) => part !== "body").join(".") : "";
    const message = entry.msg || entry.message || entry.detail || "";
    if (message && typeof message === "object") {
      const formatted = this.formatError(message);
      return location && formatted ? `${location}: ${formatted}` : formatted;
    }
    if (location && message) {
      return `${location}: ${message}`;
    }
    if (message) {
      return String(message);
    }
    try {
      return JSON.stringify(entry);
    } catch {
      return String(entry);
    }
  }
}
